import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                cartDetails: undefined,
                fetchStatus: "loading",
                error: undefined,
                addProductFetchStatus: undefined
            };
        case ActionTypes.addProductFetch:
            return {
                ...state,
                cartDetails: state.cartDetails,
                fetchStatus: state.fetchStatus,
                error: state.error,
                addProductFetchStatus: action.payload
            };
        case ActionTypes.fetchSuccess:
            return {
                ...state,
                cartDetails: action.payload.cartDetails,
                fetchStatus: "success",
                error: undefined,
                addProductFetchStatus: "initial"
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                fetchStatus: "failed",
                error: action.payload.error,
                cartDetails: undefined,
                addProductFetchStatus: state.addProductFetchStatus
            };
        case ActionTypes.reset:
            return getInitialState();
        default:
            return state;
    }
};
export { reducer, getInitialState };
